export default `
  mutation makePaymentviaToken (
    $txnid: ID!
    $override_amount: Float
    $token: String!
    $authorization: String
  ) {
    receipt: makePayment (
      txnid: $txnid
      cardtoken: $token
      authorization: $authorization
      override_amount: $override_amount
    ) {
      ...Receipt
    }
  }

  mutation makePaymentviaPayerID (
    $txnid: ID!
    $override_amount: Float
    $payerid: String!
    $authorization: String
  ) {
    receipt: makePayment (
      txnid: $txnid
      payerid: $payerid
      authorization: $authorization
      override_amount: $override_amount
    ) {
      ...Receipt
    }
  }

  mutation makePaymentviaTokenwithAmount (
    $txnid: ID!
    $amount: Float
    $override_amount: Float
    $token: String!
    $authorization: String
  ) {
    receipt: makePayment (
      txnid: $txnid
      cardtoken: $token
      authorization: $authorization
      override_amount: $override_amount
      amount: $amount
    ) {
      ...Receipt
    }
  }

  mutation makePaymentviaPayerIDwithAmount (
    $txnid: ID!
    $amount: Float
    $override_amount: Float
    $payerid: String!
    $authorization: String
  ) {
    receipt: makePayment (
      txnid: $txnid
      payerid: $payerid
      authorization: $authorization
      amount: $amount
      override_amount: $override_amount
    ) {
      ...Receipt
    }
  }

`
